const i18n = window.plansConfig.i18n;

export default i18n;
